module.exports = __webpack_public_path__ + "img/houdini-book.ebd4a93.jpg";